export default "__VITE_ASSET__47445fdd__"